import React, { useState, useEffect, useCallback } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Image, Platform, Linking, Alert, ScrollView, KeyboardAvoidingView } from 'react-native';
import { useSelector } from 'react-redux';
import DaniLeesLogo from './assets/DaniLees_Logo.png';
import API_PATHS from './apiCalls/ApiPath';
// import { toast, ToastContainer } from 'react-toastify';
import Toast from 'react-native-toast-message';
import AsyncStorage from '@react-native-async-storage/async-storage';
import TopGreenHeader from './screens/Common/TopGreenHeader';


const ProfileScreen = ({ navigation }) => {

  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [specialInstructions, setSpecialInstructions] = useState('');

  const fetchUserData = useCallback(async () => {
    try {
      const userId = await AsyncStorage.getItem('userId');
      const token = await AsyncStorage.getItem('token');
      const response = await fetch(
        `${API_PATHS.BASE_URL}${API_PATHS.PROFILE_API}/${userId}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await response.json();
      if (data.Success === 1 && data.Data.response.parent) {
        const parentData = data.Data.response.parent;
        setName(parentData.name || '');
        setPhone(parentData.phoneNumber || '');
        setEmail(parentData.email || '');
        setSpecialInstructions(parentData.discription || '');
      } else {
        Toast.show({
          type: 'error',
          text1: 'Failed to fetch user details',
        });
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      Toast.show({
        type: 'error',
        text1: 'Something went wrong while fetching data',
      });
    }
  }, []);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const handleUpdate = async () => {
    try {
      const userId = await AsyncStorage.getItem('userId');
      const token = await AsyncStorage.getItem('token');
      const response = await fetch(
        `${API_PATHS.BASE_URL}${API_PATHS.EDIT_PARENT_DETAILS}`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            parentId: userId,
            name: name,
            phoneNumber: phone,
            email: email,
            discription: specialInstructions,
          }),
        }
      );

      const result = await response.json();

      if (response.ok && result.Success === 1) {
        Toast.show({
          type: 'success',
          text1: 'User details updated successfully',
        });
      } else {
        Toast.show({
          type: 'error',
          text1: 'Failed to update user details',
        });
      }
    } catch (error) {
      Toast.show({
        type: 'error',
        text1: 'Something went wrong while updating details',
      });
    }
  };

  const navigateTo = (screen) => {
    navigation.navigate(screen);
  }


  const handlePasswordUpdate = async () => {
    const userId = await AsyncStorage.getItem('userId');
    Linking.openURL(`https://admin.danileeshelpinghands.org/update-password/1/${userId}`);
  };

  return (
    <View style={styles.container}>
      {/* <ToastContainer /> */}
      <TopGreenHeader Heading="Profile" isBackIcon={true} isNotification={false} navigation={navigation} />

      <ScrollView contentContainerStyle={styles.content}>
        {/* <KeyboardAvoidingView style={{ width: '100%', flexDirection: 'column', justifyContent: 'center', backgroundColor: 'red' }} behavior='padding'> */}
        <Image source={DaniLeesLogo} style={styles.logo} />
        <TextInput
          style={styles.input}
          placeholderTextColor="#505766"
          value={name}
          onChangeText={setName}
          placeholder="Name"
        />
        <TextInput
          style={styles.input}
          placeholderTextColor="#505766"
          value={phone}
          onChangeText={setPhone}
          placeholder="Phone Number"
          keyboardType="phone-pad"
        />
        <TextInput
          style={styles.input}
          placeholderTextColor="#505766"
          value={email}
          onChangeText={setEmail}
          placeholder="E-mail"
          keyboardType="email-address"
        />

        {/* Add a text field here with placeholder Special Instructions , this is just a text field with instructions and can be anything */}
        <TextInput
          style={[styles.input, { height: 100, textAlignVertical: 'top', paddingTop: 15 }]}
          placeholderTextColor="#505766"
          value={specialInstructions}
          onChangeText={setSpecialInstructions}
          placeholder="Instructions"
          multiline={true}
          numberOfLines={4}
        />
        <TouchableOpacity style={styles.button} onPress={handleUpdate}>
          <Text style={styles.buttonText}>Update</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.passwordButton} onPress={handlePasswordUpdate}>
          <Text style={styles.buttonText}>Update Password</Text>
        </TouchableOpacity>
        <TouchableOpacity style={[styles.passwordButton, { marginTop: 15 }]} onPress={() => navigateTo("SelectKidScreen1")}>
          <Text style={styles.buttonText}>Kids</Text>
        </TouchableOpacity>
        <TouchableOpacity style={[styles.passwordButton, { marginTop: 15 }]} onPress={() => navigateTo('AddressScreen')}>
          <Text style={styles.buttonText}>Addresses</Text>
        </TouchableOpacity>
        <TouchableOpacity style={[styles.passwordButton, { marginTop: 15 }]} onPress={() => navigateTo('DocumentsList')}>
          <Text style={styles.buttonText}>Documents</Text>
        </TouchableOpacity>
        {/* </KeyboardAvoidingView> */}
      </ScrollView>


    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F5F5F5',
  },
  backIcon: {
    height: 30,
    width: 15,
  },
  notificationIcon: {
    height: 30,
    width: 28,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#A6CE39',
    padding: 16,
  },
  headerText: {
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#fff',
    fontSize: 28,
  },
  content: {
    alignItems: 'center',
    padding: 20,
  },
  logo: {
    width: 250,
    height: 110,
    marginBottom: 30,
    resizeMode: 'contain',
  },
  input: {
    width: '90%',
    height: 50,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#938F99',
    color: "#000",
    borderRadius: 4,
    marginBottom: 15,
    paddingHorizontal: 15,
    fontSize: 18,
  },
  button: {
    width: '30%',
    height: 45,
    backgroundColor: '#A6CE39',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 15,
  },
  passwordButton: {
    width: '50%',
    height: 45,
    backgroundColor: '#A6CE39',
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    fontFamily: Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    color: '#fff',
    fontSize: 18,
  },
});

export default ProfileScreen;
